module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reviews_count":"%{count} reviews","review_description":"{percentage} rated this product <b>{score}</b>."}}')
  delete Component.options._Ctor
}
